export enum PopupButtonAction {
  BACK = "BUTTON_CLICKED_BACK",
  SUBMIT = "BUTTON_CLICKED_SUBMIT"
}